module.exports = __webpack_public_path__ + "img/hotdog-top-002sp.9ffb723a.jpg";